export enum StatusCommissionEnum{
  DRAFT = "DRAFT",
  CLOSED= 'CLOSED',
  PAID = 'PAID',
  ALL= 'ALL'
}
